import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../components/CatalogForm/validators';
import { CpacValorService } from '../../../services/CpacValorService';

const CpacValorForm = () => {
  const routeParams = useParams() || {};
  const id = routeParams.id || null;

  // Pre-load data in edit mode
  const loadData = useCallback(async (recordId) => {
    return await CpacValorService.obtenerPorId(recordId);
  }, []);

  // Submit handler
  const handleSubmit = useCallback(async (values) => {
    const payload = {
      ...values,
      id: id,
      rangoini: values.rangoini !== '' ? Number(values.rangoini) : values.rangoini,
      cpac: values.cpac !== '' ? Number(values.cpac) : values.cpac,
    };
    return await CpacValorService.guardar(payload);
  }, [id]);

  // Form field configurations
  const fields = useMemo(() => [
    {
      name: 'rangoini',
      label: 'Rango Inicial',
      type: 'number',
      col: 6,
      required: true,
      placeholder: 'Ej. 0.00',
      validators: [
        Validators.required('El rango inicial es obligatorio'),
        Validators.number('El rango inicial debe ser un número válido'),
      ],
    },
    {
      name: 'cpac',
      label: 'Valor CPAC',
      type: 'number',
      col: 6,
      required: true,
      placeholder: 'Ej. 1.25',
      validators: [
        Validators.required('El valor CPAC es obligatorio'),
        Validators.number('El valor CPAC debe ser un número válido'),
      ],
    },
  ], []);

  return (
    <CatalogForm
      title="Valor CPAC"
      subtitle="Configuración de rangos y valores para el cálculo de CPAC"
      fields={fields}
      initialValues={{
        rangoini: '',
        cpac: '',
      }}
      id={id}
      loadData={loadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/CpacValores"
    />
  );
};

export default CpacValorForm;
